import {useEffect, useState} from "react";
import {Spinner, TitlePage} from "../../shared";
import {Link} from "react-router-dom";
import {getDeviceLocation, getDeviceType} from "../../../utils/devices-constants";
import {SquadflixLinkingApi} from "../../../apis/squadflix-linking-api/squadflix-linking-api";

const SquadflixDevicesPage = () => {

    const [devices, setDevices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        SquadflixLinkingApi.getUserDevices().then(response => {
            if (response?.devices) {
                setDevices(response.devices);
                console.log("Fetched devices:", response.devices);
            }
        }).catch(error => {
            console.error("Error fetching user devices:", error);
        }).finally(() => {
            setLoading(false);
        })
    }, []);

    const handleDeleteDevice = (deviceId) => {
        if (!deviceId) return;
        if (!window.confirm("¿Estás seguro de que deseas eliminar este dispositivo?")) return;

        setLoading(true);
        SquadflixLinkingApi.deleteDevice({deviceId}).then(response => {
            if (response?.success) {
                setDevices(prev => prev.filter(d => d.deviceId !== deviceId));
            }
        }).catch(error => {
            console.error("Error deleting device:", error);
        }).finally(() => {
            setLoading(false);
        });
    }

    if (loading) {
        return <div className="d-flex justify-content-center align-items-center">
            <Spinner/>
        </div>
    }

    return (
        <div className="squadflix-devices-page">
            <TitlePage title="Dispositivos SquadFlix TV" hideSeparator leftClass="col-12"/>
            {devices.length === 0 ? (
                <div className="alert alert-info mt-4 mb-5" role="alert">
                    No tienes dispositivos vinculados. Vincula un dispositivo para empezar a usar SquadFlix TV.
                </div>
            ) : (
                <div className="d-flex flex-column gap-3 mt-4 mb-5">
                    {devices.map(device => (
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5 className="card-title">{device.name}</h5>
                                    <button onClick={() => handleDeleteDevice(device.deviceId)}
                                            className="btn btn-danger"><i className="fa-solid fa-trash"></i></button>
                                </div>
                                <div className="d-flex gap-2">
                                    <span className="badge bg-secondary">{getDeviceType(device.type)}</span>
                                    <span className="badge bg-secondary">{getDeviceLocation(device.location)}</span>
                                    <span
                                        className="badge bg-secondary">{new Date(device.linkedAt).toLocaleDateString()}</span>
                                </div>
                            </div>
                            <div className="card-footer text-muted">
                                <small>ID: {device.deviceId}</small>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <div className="squadflix-devices-page__link-new-device">
                <TitlePage title="¿Vincular un nuevo dispositivo?" hideSeparator leftClass="col-12"/>
                <p className="pt-3">Para vincular un nuevo dispositivo, navega a https://squadflixtv.web.app/ en este y
                    sigue los pasos que se muestren en la pantalla. Puedes introducir el código del dispositivo que
                    quieres emparejar <Link to="/squadflix/link">aquí</Link>.</p>
            </div>
        </div>
    );
}

export default SquadflixDevicesPage;
